import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';

export const AppearanceSettings = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          Design
        </h3>
        <div className="mt-6">
          <div className="flex items-center justify-between">
            <span className="flex-grow flex flex-col">
              <span className="text-sm font-medium text-gray-900 dark:text-white">Dark Mode</span>
              <span className="text-sm text-gray-500 dark:text-gray-400">
                Wechseln zwischen hellem und dunklem Design
              </span>
            </span>
            <button
              onClick={toggleDarkMode}
              className={`
                relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent 
                transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2
                ${isDarkMode ? 'bg-indigo-600' : 'bg-gray-200'}
              `}
            >
              <span className="sr-only">Dark Mode verwenden</span>
              <span
                className={`
                  pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 
                  transition duration-200 ease-in-out flex items-center justify-center
                  ${isDarkMode ? 'translate-x-5' : 'translate-x-0'}
                `}
              >
                {isDarkMode ? (
                  <Moon className="h-3 w-3 text-indigo-600" />
                ) : (
                  <Sun className="h-3 w-3 text-yellow-400" />
                )}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};